import {
  React,
  Component,
  helpers,
} from 'imports/CommonImports';

import {
  Slider,
  TextField,
} from 'material-ui';

/**
 * The slider bar can have a set minimum and maximum, and the value can be
 * obtained through the value parameter fired on an onChange event.
 */

const maxGetter = {
  'USD': 100000000,
  'CLP': 100000000000,
  'UF': 50000000,
  'EUR': 100000000
}

const powerGetter = {
  'USD': 9,
  'CLP': 12,
  'UF': 8,
  'EUR': 9
}

const stepGetter = {
  'USD': 5000,
  'CLP': 1000000,
  'UF': 1000,
  'EUR': 5000
}

const styles = {
  slider: {
    margin: '0.2em 0 0 0'
  },
  textContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  textField: {
    margin: '0 1em',
  },
  textArea: {
    textAlign: 'right',
  }
}

export default class EconomicImpactSlider extends Component {
  constructor(props){
    super(props);
    this.state = {
      slider: props.economicImpact || 0,
      max: maxGetter[props.currency],
      power: powerGetter[props.currency],
      step: stepGetter[props.currency]
    }
  }

  render() {
    return (
      <div style={this.props.style}>
        <div style={styles.textContainer}>
          Aporte mínimo:
          <TextField
            value={helpers.numberWithDots(this.state.slider)}
            style={styles.textField}
            textareaStyle={styles.textArea}
            onChange={this.handleText}/>
          <div>{this.props.currency}</div>
        </div>

      </div>
    );
  }

  handleText = (event) => {
    let value = parseInt(helpers.numberWithoutDots(event.target.value), 10) || '';
    this.setState({slider: value});
    this.props.handleChange(value);
  }

  // handleSlider = (event, value) => {
  // <Slider
  //   min={0}
  //   max={this.state.max}
  //   step={this.state.max / 100}
  //   value={this.reverse(this.state.slider)}
  //   onChange={this.handleSlider}
  //   sliderStyle={styles.slider}
  // />
  //   var transformedValue = this.transform(helpers.numberWithoutDots(value)) >= 0 ? parseInt(this.transform(helpers.numberWithoutDots(value)) / this.state.step, 10) * this.state.step : 0
  //   this.setState({slider: transformedValue});
  //   this.props.handleChange(transformedValue);
  // };

  transform = (value) => {
    return Math.round((Math.exp(this.state.power * value / this.state.max) - 1) / (Math.exp(this.state.power) - 1) * this.state.max);
  }

  reverse = (value) => {
    return (1 / this.state.power) * Math.log(((Math.exp(this.state.power) - 1) * value / this.state.max) + 1) * this.state.max;
  }
}



// WEBPACK FOOTER //
// ./src/components/selection/EconomicImpactSlider.js